import * as React from 'react';
export const sparkasseSvg = React.forwardRef(function sparkasseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E60005',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M16 4.36c-1.15 0-2.2.67-2.7 1.7-.3.78-.3 1.64 0 2.4.15.34.39.63.65.88a2.9 2.9 0 0 0 4.1 0c.26-.25.48-.54.64-.87a3.2 3.2 0 0 0 0-2.4 2.8 2.8 0 0 0-1.54-1.49A3.05 3.05 0 0 0 16 4.36zm-5.82 7.28a2.9 2.9 0 0 0-2.08.81 3.1 3.1 0 0 0-.83 2.1v5.81h13.1v1.46H7.26v1.45c0 .4.09.88.24 1.21.28.68.84 1.21 1.54 1.47.35.14.72.23 1.13.23h11.64a3.05 3.05 0 0 0 2.7-1.7c.16-.35.2-.81.2-1.2v-5.83H11.65V16h13.09v-1.45c0-.4-.05-.86-.2-1.2a2.9 2.9 0 0 0-2.68-1.71H10.18z',
      }),
    ),
  );
});
sparkasseSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var sparkasse = {
  category: 'brand',
  colorable: false,
  name: 'sparkasse',
  svg: sparkasseSvg,
};
